import React from 'react';
import styles from '../../styles/portfolio/short_desc.scss';


export const AuthServiceDesc = props => {
    return (
        <div className={styles.description}>
            <div className={styles.containerGeneric}>
                A <b>set of microservices</b> that implement the <b>OAuth2</b> protocol and can be used to provide
                a frontend with secure:
                <ul>
                    <li>Redirection to authorization-server</li>
                    <li>Secure access, refresh, and id token exchange</li>
                    <li>Secure token usage in the frontend <i>(without storage)</i></li>
                    <li>Token refresh</li>
                </ul>
                Simplified Authorization Server for local testing is included.
                <span className={styles.tagContainer}>OAuth2</span>
            </div>
        </div>
    )
};
